import {  MODULE } from "./consts";
import InventoryDashboard from "./InventoryDashboard";

export const InventoryRoutes = [
  { path: `/${MODULE}`, exact: true, component: InventoryDashboard },
];

export default InventoryRoutes;
